// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.property.LeasingPropertyOuidWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetPropertyInfoFromOuidResponseDto } from '../..';

interface GetPropertyInfoFromOuidParams {
  ouid: string;
}

export const LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_Path = '/api/web/v1/ouid/getPropertyInfoFromOuid';

/**
 * get property data for listing from ouid
 */
export const LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid = (
  getParams: GetPropertyInfoFromOuidParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPropertyInfoFromOuidParams, never, GetPropertyInfoFromOuidResponseDto>(
    {
      getParams: getParams,
      endpoint: LeasingPropertyOuidWebApiHandler_getPropertyInfoFromOuid_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
